/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Move Word To Previous Event" |
*
* @param {Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wort zum vorherigen Ereignis verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la parola all'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить слово к предыдущему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover palabra al evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将单词移至上一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を前のイベントに移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द को पिछली घटना में ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover palavra para o evento anterior")
	return /** @type {LocalizedString} */ ("Move Word To Previous Event")
});